import {FireInTheHole2} from "../../FireInTheHole2";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";

export class FreespinIntroPresentation implements FlowStatePresentation {
    name: string = "FreespinWinPresentation";
    private _flowStateController: FlowStateController;

    shouldRun(): boolean {
        return FireInTheHole2.model.freespinTriggeredThisSpin;
    }

    start(controller: FlowStateController): void {
        this._flowStateController = controller;
        FireInTheHole2.freespinIntro.show(() => this.complete(), FireInTheHole2.apiPlugin.isReplay);
    }

    public complete(): void {
        FireInTheHole2.keypadPlugin.show(0.2);
        FireInTheHole2.fsLeftView.update(3);
        this._flowStateController.finish();
    }
}